import React, { useState, useEffect } from 'react'
import { Drawer, Form, Button, notification, Card, Row, Col, TimePicker, Select, Icon, Input } from 'antd'
import { FormUtils as GetAllFormFields } from 'sz-react-utils-lite'
import { useDispatch, useSelector } from 'react-redux'
import {
  addScheduleMeeting,
  getScheduleMeeting,
  scheduleMeetingUsersList,
  updateScheduleMeeting
} from '../actions/scheduleMeeting'
import { createMatchSelector, goBack } from 'connected-react-router'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { getCountry } from '../../countries/actions/countries'
import { durationList, InputBox, ScheduleTypes } from '../../../components/_utils/appUtils'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { listAllStudents, searchedStudent } from '../../student/actions/student'
import debounce from 'lodash/debounce'
import { listAllUsers } from '../../users/actions/user'
import moment from 'moment'
import _ from 'lodash'

const { Option } = Select
const format = 'h:mm A'

const Edit = (props) => {
  const dispatch = useDispatch()
  let { visible, setVisible } = props
  let [userList, setUserList] = useState([])
  let [guestUsers, setGuestUsers] = useState([])
  let [time, setTime] = useState(null)
  let [email, setEmail] = useState(null)
  let [meetingId, setMeetingId] = useState(null)
  const { form: { getFieldDecorator, setFieldsValue, getFieldValue, resetFields }, events, id } = props
  useEffect(() => {
    loadUser()
  }, [])

  const chooseGuestEmail = (email) => {
    if (!email) {
      return notification.warning({ message: 'Enter email' })
    }
    email = email.toLowerCase().trim()
    if (email.indexOf('@') > 0) {
      let find = _.find(guestUsers, (item) => {
        return email == item
      })
      if (find) {
        notification.warning({ message: 'Email already exists.' })
      } else {
        setGuestUsers([...guestUsers, email])
        setEmail(null)
      }
    } else {
      notification.warning({ message: 'Enter valid email' })
    }
  }

  const removeGuestEmail = (index) => {
    let cloneEmail = _.clone(guestUsers)
    cloneEmail.splice(index, 1)
    setGuestUsers(cloneEmail)
  }
  const onChange = (value) => {
    setTime(value)
  }
  const loadUser = async () => {
    let { data } = await dispatch(scheduleMeetingUsersList({}))
    setUserList(data)
  }


  let formFields = [
    { key: 'topic', label: 'Topic', required: true, placeholder: 'Enter Topic', span: 24 },
    {
      key: 'types',
      label: 'Type',
      required: true,
      type: 'select',
      showSearch: true,
      mode: 'multiple',
      span: 12,
      options: ScheduleTypes,
      keyAccessor: x => x,
      valueAccessor: x => `${x}`,
      onChange: x => {
        props.form.setFieldsValue({
          types: x
        })
      }
    },
    {
      key: 'date',
      label: 'Date',
      required: true, type: 'date',
      placeholder: 'Choose Date', span: 12
    },
    {
      key: 'fromTime',
      label: 'From Time',
      required: true,
      type: 'time',
      use12Hours: true,
      placeholder: 'Choose From Time', span: 12,
      minuteStep: 15,
      format: format
    },

    {
      key: 'duration',
      label: 'Duration',
      required: true,
      type: 'select',
      span: 12,
      options: durationList,
      keyAccessor: x => x.value,
      valueAccessor: x => `${x.label}`,
      onChange: x => {
        props.form.setFieldsValue({
          duration: x
        })
      }
    },

    {
      key: 'place', label: 'Place', placeholder: 'Enter Place', span: 12,
      hidden: !(getFieldValue('types') && getFieldValue('types').includes('Physical'))
    },
    {
      key: 'user',
      label: 'User',
      required: true,
      type: 'select',
      showSearch: true,
      span: 12,
      options: userList,
      keyAccessor: x => x.email,
      valueAccessor: x => `${x.label}`,
      onChange: x => {
        props.form.setFieldsValue({
          user: x
        })
      }
    }

  ]


  const submitFormLayout = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 10, offset: 7 },
      md: { span: 12, offset: 8 }
    }
  }
  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  useEffect(() => {
    getScheduleMeetingFxn()
  }, [])

  const getScheduleMeetingFxn = async () => {
    if (id) {
      let data = await dispatch(getScheduleMeeting(id))
      if (data) {
        setMeetingId(data._id)
        if (data.date) {
          data.date = moment(data.date)
        }
        setFieldsValue({
          topic: data.topic,
          date: data.date,
          types: data.types,
          fromTime: moment(data.fromTime),
          duration: data.duration,
          user: data.user
        })
        setTimeout(() => {
          setFieldsValue({ place: data.place })
        }, 500)
        setGuestUsers(data.guestUsers)


      }
    }
  }


  const handleSubmit = e => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {

        valData.guestUsers = guestUsers
        let user = _.find(userList, (item) => {
          return item.email == valData.user
        })
        valData.userName = user && user.name ? user.name : null

        let data = await dispatch(updateScheduleMeeting(valData, meetingId))

        events.hideEditDrawer()
      } else {
        notification.warning({
          message: 'Fill All Required Fields'
        })
      }
    })
  }


  return <div>
    <Drawer
      visible={visible}
      width={'70%'}
      placement="right"
      onClose={() => events.hideEditDrawer()}
      title={'Edit Schedule Meeting'}>
      <div className="form-box">
        <div className="card unizportal">
          <Form style={{ marginTop: 8, textAlign: 'left' }}>
            <Row gutter={16} className={'rowWrap'}>
              {formFields.map((item, key) => {
                return (
                  !item.hidden ? <Col span={item.span} key={key}>
                    <GetEachFormFields
                      item={item}
                      getFieldDecorator={getFieldDecorator}
                      formItemLayout={formItemLayout}/>
                  </Col> : null
                )
              })}

              <Col span={12}>
                <InputBox title={'Enter Guest Email'} className={'rowFlex'}>
                  <Input className={'form-control'} type={'email'} value={email}
                         onChange={(e) => setEmail(e.target.value)}/>
                  <Button type="primary" icon="plus" className={'circleBtn'} onClick={() => chooseGuestEmail(email)}/>
                </InputBox>
              </Col>
              {guestUsers && guestUsers.length ? <Col span={24}>
                <div className={'guestEmailBox'}>
                  <ul>
                    {guestUsers.map((item, index) => {
                      return (
                        <li className={'emailTag'} key={index}>
                          {item} <Icon type={'close'} onClick={() => removeGuestEmail(index)} className={'emailIcon'}/>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </Col> : null}
              <Col span={24}>
                <Form.Item className={'mt20'}>
                  <Button type="success" onClick={handleSubmit} className={'btn'}>
                    SUBMIT
                  </Button>
                </Form.Item>
              </Col>
            </Row>

          </Form>
        </div>
      </div>
    </Drawer>
  </div>
}

const EditCountry = Form.create()(Edit)
export default EditCountry
